import React from 'react';
import resolveConfig from 'tailwindcss/resolveConfig';

import Spinner from '@repo/ui-components/form/Spinner';
import SpinnerContainer from '../../../../packages/ui-components/SpinnerContainer';

import tailwindConfig from '../../tailwind.config';

function StyledSpinner(): JSX.Element {
  const fullConfig = resolveConfig(tailwindConfig);

  return (
    <SpinnerContainer>
      <Spinner color={fullConfig.theme.colors.primary.DEFAULT} />
    </SpinnerContainer>
  );
}

export default StyledSpinner;
